import React from "react"

class UserCampers extends React.Component {
  render() {
    return <div>USER CAMPERS</div>
  }
}

export default UserCampers



// WEBPACK FOOTER //
// ./src/scenes/User/UserCampers/index.js